import React from "react";

import HeaderAvatai from "../../avatai/HeaderAvatai";
import HeaderPelex from "../../pelex/HeaderPelex";
import {isInAvataiSite} from "../Utils";

const Header = () => {
  if (isInAvataiSite())
    return (
      <HeaderAvatai />
    );
  else
    return (
      <HeaderPelex />
    );
};

export default Header;
